import React from "react";
import { Box, CircularProgress, styled } from "@mui/material";

const PageLoaderContainer = styled(Box)({
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  height: "100vh",
});

const PageLoader: React.FC = () => {
  return (
    <PageLoaderContainer>
      <CircularProgress />
    </PageLoaderContainer>
  );
};

export default PageLoader;
